import { render } from "./TabReturns.vue?vue&type=template&id=464f732d"
import script from "./TabReturns.vue?vue&type=script&lang=js"
export * from "./TabReturns.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__